import { useState } from "react";

const { REACT_APP_SSO_DOMAIN } = process.env;

export function useLoginCheck(email) {
  const [loading, setLoading] = useState(false);
  const [isPasswordLogin, setIsPasswordLogin] = useState(false);

  const onFormSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    if (!email) {
      setLoading(false);
      return;
    }

    const response = await fetch(
      `${REACT_APP_SSO_DOMAIN}/login-check${window.location.search}`,
      {
        method: "POST",
        body: JSON.stringify({
          email,
        }),
      },
    );

    const json = await response.json();

    if (!response.ok) {
      console.error("Error during login check:", json);
      setLoading(false);
      return;
    }

    if (json.authType === "redirect" && json.redirectUrl) {
      window.location.href = json.redirectUrl;
      return;
    }

    setIsPasswordLogin(true);
    setLoading(false);
  };

  return {
    loading,
    isPasswordLogin,
    setIsPasswordLogin,
    onFormSubmit,
  };
}
